import { TableColumn, TableRow, TableCell } from '../Table/Table.utils';

export interface ContractInfoTableContent {
  header: TableColumn;
  rows: TableRow[];
  cells: Record<string, TableCell>;
  hideDescriptionRow: boolean;
  hideSpecialTermsRow: boolean;
}

export const hideRowByCellIds = (cellIds: string[], table: ContractInfoTableContent) => {
  const { rows } = table;

  const updatedRows = [...rows];
  let shouldModify = false;
  let rowIndexToModify = -1;
  cellIds.forEach((cellId, index) => {
    rowIndexToModify = rows.findIndex(row => row.cellIds.includes(cellId));
    if (rowIndexToModify + 1) {
      shouldModify = index ? shouldModify : true;
    } else {
      shouldModify = false;
      rowIndexToModify = -1;
    }
  });

  if (rowIndexToModify + 1) {
    if (Object.hasOwn(updatedRows[rowIndexToModify], 'hidden')) {
      updatedRows[rowIndexToModify] = { ...updatedRows[rowIndexToModify], hidden: true };
    }
  }

  return {
    ...table,
    rows: updatedRows,
  };
};

export const showRowByCellIds = (cellIds: string[], table: ContractInfoTableContent) => {
  const { rows } = table;

  const updatedRows = [...rows];
  let shouldModify = false;
  let rowIndexToModify = -1;
  cellIds.forEach((cellId, index) => {
    rowIndexToModify = rows.findIndex(row => row.cellIds.includes(cellId));
    if (rowIndexToModify + 1) {
      shouldModify = index ? shouldModify : true;
    } else {
      shouldModify = false;
      rowIndexToModify = -1;
    }
  });

  if (rowIndexToModify + 1) {
    if (Object.hasOwn(updatedRows[rowIndexToModify], 'hidden')) {
      updatedRows[rowIndexToModify] = { ...updatedRows[rowIndexToModify], hidden: false };
    }
  }

  return {
    ...table,
    rows: updatedRows,
  };
};
